<template>
  <div class="card shadow-lg mb-5">
    <div class="card-body">
      <!-- Vertical tabs -->
      <div class="row">
        <div class="col-3">
          <ul class="nav nav-tabs flex-column" role="tablist">
            <li class="nav-item">
              <a href="" data-bs-target="#home" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none active">
                {{ $t('details') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="" data-bs-target="#presenters" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none">
                {{ $t('presenter') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="" data-bs-target="#tags" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none">
                {{ $t('tags') }}
              </a>
            </li>
            <li v-if="!inCollection" class="nav-item">
              <a href="" data-bs-target="#availability" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none">
                {{ $t('availability') }}
              </a>
            </li>
            <li v-if="!inCollection" class="nav-item">
              <a href="" data-bs-target="#attachments" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none">
                {{ $t('Section.attachments') }}
              </a>
            </li>
            <li v-if="!inCollection" class="nav-item">
              <a href="" data-bs-target="#privacy" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none">
                {{ $t('privacy-and-security') }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-9">
          <div v-if="!busy" id="myTabContent" class="tab-content">
            <div id="home" role="tabpanel" aria-labelledby="home-tab" class="tab-pane fade show active">
              <form v-if="mediaForm" @submit.prevent="onSubmit">
                <div class="form-group">
                  <label for="media_title" class="fw-bold pb-2 opacity-80">{{ $t('network.networkForm.mediaTitle') }}</label>
                  <input id="media_title" v-model="mediaForm.title" data-test="media_title" class="form-control rounded-0" required placeholder>
                  <p class="alert rounded-1 alert-warning text-black fw-semibold mt-3 py-2 px-3" style="font-size: small;">
                    {{ $t('exercise-caution-when-updating-the-media-title-as-it-will-change-the-associated-link-potentially-causing-broken-links-for-prior-shares') }}
                  </p>
                </div>

                <div class="form-group pb-3">
                  <label class="fw-bold pb-2 opacity-80" for="mediaType">{{ $t('network.networkForm.mediaType') }}</label><br />
                  <span style="text-transform: capitalize;">{{ mediaForm.type }}</span>
                  <span v-if="mediaForm.type == 'video'">
                    <button id="refresh_thumbnail" data-test="refresh_thumbnail" class="btn btn-primary btn-sm mx-4" @click="refreshMetadata(media.vimeo_number)">
                      {{ $t('network.networkForm.refresh-thumbnail') }}
                    </button>
                    <a id="add_thumbnail" data-test="add_thumbnail" :href="'https://vimeo.com/manage/' + media.vimeo_number + '/advanced/'"
                    class="btn btn-outline-primary btn-sm" style="border: 2px solid;" target="_blank">
                      <i class="fas fa-arrow-up-right-from-square"></i>
                      {{ $t('network.networkForm.add-thumbnail') }}
                    </a>
                    <a id="download_transcript" data-test="download_transcript" :href="'https://vimeo.com/manage/videos/' + media.vimeo_number + '/transcript'"
                    class="btn btn-outline-primary btn-sm mx-4" style="border: 2px solid;" target="_blank">
                      <i class="fas fa-arrow-up-right-from-square"></i>
                      Download transcript
                    </a>
                  </span>
                </div>

                <div class="form-group pb-3">
                  <label for="description" class="fw-bold pb-2 opacity-80">{{ $t('network.networkForm.description') }}</label>
                  <textarea id="description" v-model="mediaForm.description" data-test="description" rows="5" class="form-control rounded-0" required></textarea>
                </div>

                <div class="row">
                  <div class="col-6 pe-2 ps-0">
                    <div class="form-group pb-3">
                      <label for="publishDate" class="fw-bold pb-2 opacity-80">{{ $t('network.networkForm.publishDate') }}</label>
                      <div>
                        <date-picker
                          id="publishDate"
                          ref="datepicker"
                          v-model="mediaForm.publish_date"
                          data-test="publishDate"
                          :placeholder="$t('network.networkForm.publishDate')"
                          :clearable="false"
                          :valueType="'format'"
                          class="w-100 custom-datepicker"
                          @change="$refs.datepicker.value = mediaForm.publish_date"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 ps-2 pe-0">
                    <div class="form-group pb-3">
                      <label for="language" class="fw-bold pb-2 opacity-80">{{ $t('Nav.language') }}</label>
                      <v-select
                        id="language"
                        v-model="mediaForm.language"
                        data-test="language"
                        :options="languages"
                        label="language"
                        :clearable="false"
                      ></v-select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div id="presenters" role="tabpanel" aria-labelledby="presenters-tab" class="tab-pane fade">
              <div v-if="mediaForm.presenters" class="form-group pb-2">
                <PresenterField :media_id="mediaForm.id" :currentNetworkSlug="currentNetworkSlug" @presenter-form-field-update="presenterUpdate" />
              </div>
            </div>
            <div id="tags" role="tabpanel" aria-labelledby="tags-tab" class="tab-pane fade">
              <div class="form-group pb-2 ">
                <label for="suggestTags" class="fw-bold pb-2 opacity-80">{{ $t('network.sortOptions.suggestTags') }}</label>
                <TagFormField
                  :network_media_id="mediaForm.id"
                  @update-media-tags="updateTags"
                />
                <small class="text-muted">{{ $t('recommend-suitable-tags-by-searching-or-adding-them') }}.
                  {{ $t('you-can-use-a-comma-or-a-semicolon-to-separate-multiple-tags') }}
                </small>
              </div>
              <div v-if="mediaForm.tags" class="form-group pb-2">
                <label class="fw-bold pb-2 opacity-80">
                  <span v-if="mediaForm.tags.length == 1">{{ $t('this-media-has-1-tag') }}</span>
                  <span v-else>{{ $t('this-media-has-tags', { num: mediaForm.tags.length }) }}</span>
                </label>
                <br />
                <div v-for="(tag,index) in sortedArray(mediaForm.tags)" :key="index" role="group" aria-label="Basic example" class="btn-group btn-sm p-0 m-1">
                  <span class="bg-primary text-white btn-sm py-0 px-2 rounded-1 rounded-end-0">#{{ tag.name }}</span>
                  <button id="remove_media_tag" data-test="remove_media_tag" type="button" class="btn bg-danger btn-sm py-0 px-2" @click="removeMediaTag(tag)">
                    <i class="fa fa-close text-white"></i>
                  </button>
                </div>
              </div>
            </div>
            <div id="availability" role="tabpanel" aria-labelledby="availability-tab" class="tab-pane fade">
              <div v-if="managedNetworks && mediaForm.networks" class="form-group pb-2" >
                <label for="selectMultipleNetworks" class="fw-bold opacity-80">{{ $t('network.networkForm.selectNetwork') }}</label> 
                <v-select
                  id="selectMultipleNetworks"
                  v-model="selectNetwork"
                  data-test="selectMultipleNetworks"
                  :options="filteredManagedNetworks"
                  :filter="fuseSearch"
                  :placeholder="$t('network.networkForm.selectNetwork')"
                  :get-option-label="option => option.name + ' (' + option.short_name + ')'"
                  @input="cleanNetworkAfterSelection"
                ></v-select>
              </div>

              <div v-if="msg.networkMedia != ''" :class="msg.networkMediaClass" :style="{display: msg.networkMediaStyle}">{{ msg.networkMedia }}</div>

              <div v-if="mediaForm.networks" class="form-group py-2">
                <label class="pb-1 fw-bold opacity-80" for="">
                  <span v-if="mediaForm.networks.length == 0">{{ $t('media-available-in-1-other-network') }}</span>
                  <span v-else>{{ $t('media-available-in-other-networks', { num: mediaForm.networks.length }) }}</span>
                </label>
                  <ul class="list-group rounded-0 ">
                    <li v-for="(mediaNetwork,index) in mediaForm.networks" :key="index" class="list-group-item ps-1 text-primary"> 
                    <div class="row">
                      <div class="col-10 ps-3">{{ mediaNetwork.name }} </div>
                      <div class="col-1 text-end"><a :href="'/networks/'+mediaNetwork.slug" target="_BLANK"><i class="fa fa-external-link"></i></a></div>
                      <div role="button" class="col-1 text-end" @click="removeNetwork(mediaNetwork)"><i class="fa fa-close text-danger"></i></div>
                    </div>
                    </li>
                  </ul>
              </div>
            </div>
            <div id="attachments" role="tabpanel" aria-labelledby="attachments-tab" class="tab-pane fade">
              <div class="form-group pb-2">
                <label for="input-10" class="fw-bold pb-2 opacity-80">{{ $t('network.upload') }}</label>
                <BasicUploader @file-upload-complete="attachmentUploadComplete" />

                <div v-if="mediaForm.attachments && mediaForm.attachments.length > 0" class="col-12 mt-3">
                  <span class="fw-bold pb-2 opacity-80">{{ $t('network.message.attachedMedia') }}</span>
                  <div v-for="(attachment, index) in mediaForm.attachments" :key="index"><hr />
                    <div class="mt-2 fw-bold" style="display: flex; justify-content: space-between;">
                      <input id="attachment_title" v-model="attachment.title" data-test="attachment_title" class="form-control" @change="editAttachmentTitle(attachment)">
                      <span class="text-danger p-2" style="cursor: pointer;" @click="removeAttachment(attachment)">
                        {{ $t('network.delete') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="privacy" role="tabpanel" aria-labelledby="privacy-tab" class="tab-pane fade">
              <div id="input-group-11" :label="$t('network.networkMediaForm.permission')" label-for="input-11" class="form-group">
                <PermissionList v-if="!inCollection" v-model="mediaForm.permission" :value="mediaForm.permission" title="Choose the level of visibility for this media item" />
              </div>
              <hr v-if="mediaForm.type != 'video'" style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 20px 0px;">
              <div v-if="mediaForm.type != 'video'" class="form-check form-switch">
                <input id="can_download_media" v-model="mediaForm.can_download" data-test="can_download_media" type="checkbox" class="form-check-input" />
                <label for="can_download_media" class="form-check-label form-check-lg">Allow download</label>
              </div>
            </div>
          </div>
          <div v-else class="text-center">
            <lottie-player
              autoplay
              loop
	            speed="2.5"
              src="/img/animations/custom_loader.json"
              class="mt-6"
              style="height: 130px;"
              >
            </lottie-player>
            <p id="cancel-label mt-7">{{ $t('network.fetchingMediaDetails') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import BasicUploader from '@/components/commons/BasicUploader.vue';
import PermissionList from '../../commons/Networks/PermissionList.vue';
import PresenterField from './presenters/PresenterMediaField.vue';
import TagFormField from '@/components/commons/Tags/TagFormField.vue';
//import TagSearchForm from '@/components/commons/Tags/TagSearchForm.vue';
import { debounce, split, sortBy } from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    BasicUploader,
    PermissionList,
    PresenterField,
    TagFormField,
    //TagSearchForm,
    DatePicker,
    vSelect,
  },
  props: {
    mediaForm: {
      type: Object,
      default: null,
    },
    managedNetworks: {
      type: Array,
      default: null,
    },
    s3Params: {
      type: Array,
      default: null,
    },
    files: {
      type: Array,
      default: null,
    },
    autosave: {
      type: Boolean,
      default: true,
    },
    media: {
      type: [Object, Array],
      default: null,
    },
    busy: {
      type: Boolean,
      default: false,
    },
    inCollection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentNetworkSlug: '',
      languages: [],
      mediaFormUpdated: false,
      mediaPresenters: [],
      defaultMediaPermissions: ['public', 'authorized', 'private', 'unlisted'],
      mediaTypes: ['video', 'file'],
      searchTags : '',
      selectNetwork : [],
      msg: { 
        networkMedia : '',
        networkMediaClass : '',
        networkMediaStyle: 'none',
      },
      toggleIcon: false,
    };
  },
  computed: {
    filteredManagedNetworks(){
      const filteredNetworks = [...this.managedNetworks];
      if (this.managedNetworks && this.mediaForm.networks) {
        this.mediaForm.networks.forEach(element => {
          filteredNetworks.forEach((e, index) => {
            if (e.id === element.id) {
              this.$store.commit('REMOVE_NETWORK', index);
            }
          });
        });
      }
      return this.sortedArray(filteredNetworks);
    }
  },
  watch: {
    '$route.fullPath': {
      handler(value) {
        let path = split(value, '/');
        if (path.length == 6) {
          this.currentNetworkSlug = path[2];
        }
      },
      deep: true,
      immediate: true,
    },
    mediaForm: {
      handler: debounce(function (value) {
        this.$bus.emit('network-media-form-submit', value);
      }, 3000),
      deep: true,
    },
    selectNetwork: function(value) {
      this.$http.post('networks/media/network/add', { network : value, network_media_id : this.mediaForm.id }).then(resp => {
        if(resp.data.status){
          this.mediaForm.networks = resp.data.data;
          const index = this.managedNetworks.indexOf(value);
          if (index !== -1) {
            this.$store.commit('REMOVE_NETWORK', index);
          }
          this.msg.networkMedia = 'Network media successfully added to a network'; 
          this.msg.networkMediaClass = 'alert alert-success'; 
          this.msg.networkMediaStyle = 'block';
          setTimeout(this.removeNetworkAlert, 2000);
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch('content_language/loadLanguages').then(languages => {
      this.languages = languages;
    });
  },
  methods: {
    sortedArray(array) {
      return sortBy(array, item => item.name.toLowerCase());
    },
    cleanNetworkAfterSelection(){
      this.$nextTick(() => {
        this.selectNetwork = '';
      });
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name', 'short_name'],
        shouldSort: true,
      });

      return search.length
      ? fuse
          .search(search)
          .map(({ item }) => item)
          .filter((item) => {
            return (
              item.name.toLowerCase().includes(search.toLowerCase()) ||
              item.short_name.toLowerCase().includes(search.toLowerCase())
            );
          })
      : [];
    },
    presenterUpdate(options) {
      // sync presenters on PresenterField with Form while keeping reactive
      if (Array.isArray(options)) {
        this.mediaPresenters.splice(0);
        options.forEach(op => this.mediaPresenters.push(op));
        if (this.autosave) {
          let vm = this;
          debounce(function () {
            vm.onSubmit();
          }, 2000)();
        }
      }
    },
    attachmentUploadComplete(files) {
      this.$http.post('networks/media/' + this.mediaForm.slug + '/add-attachment', { files }).then(resp => {
        this.mediaForm.attachments.splice(0);
        resp.data.attachments.forEach(a => this.mediaForm.attachments.push(a));
      });
    },
    editAttachmentTitle(attachment) {
      this.$http.put('networks/media/' + this.mediaForm.slug + '/attachment/' + attachment.id, attachment);
    },
    removeAttachment(attachment) {
      this.showConfirmPrompt(() => {
        this.$http.delete('networks/media/' + this.mediaForm.slug + '/attachment/' + attachment.id).then(() => {
          let index = this.mediaForm.attachments.findIndex(a => a.id == attachment.id);
          this.mediaForm.attachments.splice(index, 1);
        });
      });
    },
    onSubmit() {
      let form = this.mediaForm;
      if (this.mediaPresenters.length > 0) {
        form = JSON.parse(JSON.stringify(this.mediaForm));
        form.presenters.splice(0);
        this.mediaPresenters.forEach(p => form.presenters.push(p));
      }
    },
     invitePresenter(text) {
      console.log(text);
      this.$emit('show-user-invite-modal', {
        title: this.$t('network.networkForm.inviteUser') + ' ' + text,
        userForm: { first_name: text.split(' ')[0], last_name: text.split(' ')[1] || '' },
        invitationName: text,
        showInviteModal: true,
        inInviteMode: true,
        submitText: this.$t('network.networkForm.inviteUser'),
      });
    },
    removeNetwork(network){
      if (this.mediaForm.networks.length == 1) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Deleting this file will remove it from Networks. Contact support if you wish to restore it at a later period of time or felt that you made a mistake.',
          showCancelButton: true,
          confirmButtonText : this.$t('network.delete'),
          customClass: {
            confirmButton: 'btn btn-danger mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false
        }).then( (result) => {
          if(result.isConfirmed){
            this.$swal.fire({
              icon: 'success',
              title: this.$t('success'),
            }).then(() => {
              this.$http.delete('networks/media/' + this.mediaForm.slug).then(() => {
                let path = split(this.$route.fullPath, '/');
                if (path[1] == 'media') {
                  this.$router.push('/media');
                } else {
                  this.$router.push('/networks/' + path[2] + '/media');
                }
              });
            });
          }
        });
      } else {
        this.$swal.fire({
          icon: 'warning',
          title: 'Are you sure about this?',
          showCancelButton: true,
          confirmButtonText : 'Yes, remove',
          customClass: {
            confirmButton: 'btn btn-danger mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false
        }).then( (result) => {
          if(result.isConfirmed){
            this.$http.post('networks/media/network/remove', { network : network, network_media_id : this.mediaForm.id }).then(resp => {
              if(resp){
                this.mediaForm.networks.splice(this.mediaForm.networks.indexOf(network), 1);
                this.managedNetworks.push(network);
                this.msg.networkMedia = 'Network media removed successfully'; 
                this.msg.networkMediaClass = 'alert alert-danger'; 
                this.msg.networkMediaStyle = 'block';
                setTimeout(this.removeNetworkAlert, 2000);
              }
            });
          }
        });
      }
    },
    removeNetworkAlert() {
      this.msg.networkMediaStyle = 'none';
    },
    updateTags(){
      this.$http.get('networks/media/tags/'+this.mediaForm.id).then(resp => {
        if(resp.data.status){
            this.mediaForm.tags = resp.data.data;
        }
      });
    },
    removeMediaTag(tag){
      this.$http.post('networks/media/tag/remove', { tag : tag, network_media_id : this.mediaForm.id }).then(resp => {
        if(resp){
          this.mediaForm.tags.splice(this.mediaForm.tags.indexOf(tag), 1);
        }
      });
    },
    refreshMetadata(vimeo_number) {
      this.$http.post('networks/media/' + vimeo_number + '/vimeo-refresh-metadata');
      this.$swal.fire({
        icon: 'info',
        title: this.$t('refreshing-thumbnail-for-this-media'),
        timer: 2000,
        timerProgressBar: false,
        showConfirmButton: false,
      }).then( () => {
        this.$swal.fire({
          icon: 'success',
          title: this.$t('success'),
        });
      });
      
    },
  }
};
</script>
<style scoped>
.nav .nav-item .active {
  background-color: #f7f7fc !important;
  border:0px !important;
  border-radius:0px;
  cursor: none;
  font-weight: bold;
}
</style>
<style>
.custom-datepicker .mx-input-wrapper .mx-input {
  height: 49px !important;
}
.mx-table {
  width: initial !important;
}
</style>